import { module } from 'modujs';

export default class ProductTabs extends module {

    static get settings() {
        return {
            CLASS_ACTIVE: 'is-active',
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$triggers = Array.from(this.$('trigger'))
        this.$panels = Array.from(this.$('panel'))

        // Vars
        this.currentPanelIndex = -1
        this.elStyles = this.$el.style

        // Events
        this.events = {
            click: {
                trigger: 'onClick'
            },
            mouseenter: {
                trigger: 'onMouseEnter',
            },
            mouseleave: {
                header: 'onMouseLeave',
            }
        }
    }

    init() {
        this.togglePanel()
    }

    onClick(e) {

        console.log('onClick', e)

        const index = this.$triggers.findIndex($el => $el.dataset.index === e.curTarget.dataset.index)

        if(index === this.currentPanelIndex) {
            return
        }

        this.togglePanel(this.currentPanelIndex, false)
        this.togglePanel(index, true)
    }

    onMouseEnter(e) {
        this.elStyles.setProperty('--product-tabs-indicator-hover', e.curTarget.dataset.index)
    }

    onMouseLeave() {
        this.elStyles.setProperty('--product-tabs-indicator-hover', this.currentPanelIndex)
    }

    togglePanel(index = 0, show = true) {

        const $trigger = this.$triggers[index]
        const $panel = this.$panels[index]

        $trigger?.classList.toggle(ProductTabs.settings.CLASS_ACTIVE, show)
        $trigger?.setAttribute('aria-selected', `${show}`)
        $panel?.classList.toggle(ProductTabs.settings.CLASS_ACTIVE, show)

        if(show) {
            this.elStyles.setProperty('--product-tabs-indicator-current', index)

            this.currentPanelIndex = index
        }

    }

    destroy() {

    }
}
